// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner {
  position: relative;
  overflow: hidden;
  background: #ffffff;
}
.banner::before {
  width: 100%;
  content: " ";
  opacity: 0.2;
  position: absolute;
  top: 0;
  bottom: 0;
  height: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
}
@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .banner:before {
    background-size: 100% 100%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .banner:before {
    background-size: 100% 100%;
  }
}
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .banner:before {
    background-size: 100% 100%;
  }
}
@media only screen and (max-width: 576px) {
  .banner:before {
    background-size: 100% 100%;
  }
}
.banner .brand-title-font {
  font-weight: 700;
  font-size: 44px;
  line-height: 48px;
}
.banner .brand-title-bar {
  color: #ff000f;
}
.banner .banner-content {
  position: relative;
  margin: 80px auto;
  max-width: 80%;
}
@media only screen and (max-width: 576px) {
  .banner .banner-content {
    margin: 20px auto;
    max-width: 90%;
  }
}
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .banner .banner-content {
    margin: 20px auto;
    max-width: 90%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .banner .banner-content {
    margin: 40px auto;
    max-width: 85%;
  }
}
.banner .banner-content .brand-title {
  width: 440px;
}
@media only screen and (max-width: 576px) {
  .banner .banner-content .brand-title {
    width: 220px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .banner .banner-content .brand-title {
    width: 220px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .banner .banner-content .brand-title {
    width: 320px;
  }
}
.banner .banner-content article {
  width: 670px;
  color: #0f0f0f;
  margin: 32px auto 32px 0px;
}
.banner .banner-content article p {
  margin: 0px;
}
@media only screen and (max-width: 576px) {
  .banner .banner-content article {
    width: 100%;
    margin: 8px auto 8px 0px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .banner .banner-content article {
    width: 100%;
    margin: 8px auto 8px 0px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .banner .banner-content article {
    width: 570px;
    margin: 16px auto 16px 0px;
  }
}

.articles {
  padding: 24px 20px;
  margin: 0px auto;
  max-width: 80%;
}
@media only screen and (max-width: 576px) {
  .articles {
    max-width: 90%;
  }
}
@media only screen and (min-width: 576px) and (max-width: 768px) {
  .articles {
    max-width: 90%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 992px) {
  .articles {
    max-width: 85%;
  }
}
.articles h1,
.articles h2,
.articles h3,
.articles h4,
.articles h5,
.articles h6 {
  margin: 0px;
}
.articles .tools-cards,
.articles .case-study-cards {
  display: grid;
  padding: 16px 0px 24px 0px;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
}
.articles .tools-cards .card,
.articles .case-study-cards .card {
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
}
.articles .tools-cards .card .skelton,
.articles .case-study-cards .card .skelton {
  width: auto;
  border-radius: 4px;
  animation: skeleton-loading 1s linear infinite alternate;
  color: transparent !important;
  -webkit-user-select: none;
          user-select: none;
}
.articles .tools-cards .card .skelton.skeleton-text-limit,
.articles .case-study-cards .card .skelton.skeleton-text-limit {
  line-height: 10px !important;
  margin-top: 4px;
}
@keyframes skeleton-loading {
  0% {
    background-color: #dbdbdb;
  }
  100% {
    background-color: #ebebeb;
  }
}
.articles .tools-cards .card .type,
.articles .case-study-cards .card .type {
  display: inline-block;
  font-size: 14px;
  text-transform: uppercase;
}
.articles .tools-cards .card .type.skelton,
.articles .case-study-cards .card .type.skelton {
  line-height: 12px;
}
.articles .tools-cards .card .title,
.articles .case-study-cards .card .title {
  margin: 0px;
}
.articles .tools-cards .card .content,
.articles .case-study-cards .card .content {
  margin: 12px 0px;
  color: #686868;
  height: 60px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box !important;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  white-space: normal;
}
.articles .tools-cards .card .content-link,
.articles .case-study-cards .card .content-link {
  font-size: 14px;
  font-weight: 400;
}
.articles .tools-cards .card img,
.articles .case-study-cards .card img {
  width: 100%;
  height: 160px;
  padding-bottom: 8px;
}
.articles .tools-cards .card:hover,
.articles .case-study-cards .card:hover {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  cursor: pointer;
}
.articles .case-study-cards {
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
}

.option-modal {
  display: block;
  width: 410px;
}
@media only screen and (max-width: 576px) {
  .option-modal {
    width: 100%;
  }
}
.option-modal ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
.option-modal ul li {
  padding: 8px;
}
.option-modal ul li > .option-item-wrapper {
  display: flex;
  flex-direction: column;
  padding: 4px 0;
  cursor: pointer;
}
.option-modal ul li > .option-item-wrapper > .option-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.option-modal ul li > .option-item-wrapper > .option-item > .option-text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.option-modal ul li:not(:last-child) {
  border-bottom: 1px solid #dbdbdb;
}
.option-modal ul li:first-child {
  margin-top: 24px;
}
.option-modal ul li:nth-child(2) {
  margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Home/styles/style.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_utils.scss"],"names":[],"mappings":"AAGA;EACE,kBAAA;EACA,gBAAA;EACA,mBC8GoB;ADhHtB;AAIE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,qBAAA;AAFJ;AEWY;EFLR;IACE,0BAAA;EAHJ;AACF;AEDY;EFER;IACE,0BAAA;EAEJ;AACF;AEbY;EFSR;IACE,0BAAA;EAOJ;AACF;AEzBY;EFgBR;IACE,0BAAA;EAYJ;AACF;AATE;EACE,gBAAA;EACA,eAAA;EACA,iBCnBE;AD8BN;AARE;EACE,cCqBc;ADXlB;AAPE;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;AASJ;AE3CY;EF+BV;IAMI,iBAAA;IACA,cAAA;EAUJ;AACF;AE1CY;EFwBV;IAMI,iBAAA;IACA,cAAA;EAgBJ;AACF;AEzCY;EFiBV;IAWI,iBAAA;IACA,cAAA;EAiBJ;AACF;AAfI;EACE,YAAA;AAiBN;AEhEY;EF8CR;IAII,YAAA;EAkBN;AACF;AE9DY;EFuCR;IAII,YAAA;EAuBN;AACF;AE5DY;EFgCR;IAQI,YAAA;EAwBN;AACF;AArBI;EACE,YAAA;EACA,cAAA;EACA,0BAAA;AAuBN;AArBM;EACE,WAAA;AAuBR;AEvFY;EF0DR;IAUI,WAAA;IACA,wBAAA;EAuBN;AACF;AEtFY;EFmDR;IAUI,WAAA;IACA,wBAAA;EA6BN;AACF;AErFY;EF4CR;IAeI,YAAA;IACA,0BAAA;EA8BN;AACF;;AAzBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AA4BF;AE/GY;EFgFZ;IAMI,cAAA;EA6BF;AACF;AE7GY;EFyEZ;IAMI,cAAA;EAkCF;AACF;AE3GY;EFkEZ;IAUI,cAAA;EAmCF;AACF;AEpFI;;;;;;EAMI,WAAA;AFsFR;AAvCE;;EAEE,aAAA;EACA,0BAAA;EACA,cAAA;EACA,4DAAA;AAyCJ;AAvCI;;EACE,aAAA;EACA,mBCKgB;EDJhB,kBAAA;AA0CN;AAxCM;;EEpCF,WAAA;EACA,kBD1EC;EC2ED,wDAAA;EACA,6BAAA;EACA,yBAAA;UAAA,iBAAA;AFgFJ;AE9EI;;EACI,4BAAA;EACA,eDjFH;ADkKL;AE9EI;EACI;IACI,yBDbI;ED6Fd;EE7EM;IACI,yBDhBI;ED+Fd;AACF;AAzDM;;EACE,qBAAA;EACA,eCvGM;EDwGN,yBAAA;AA4DR;AA1DQ;;EACE,iBC9FQ;AD2JlB;AAzDM;;EACE,WAAA;AA4DR;AAzDM;;EACE,gBAAA;EACA,cC5DQ;ED6DR,YAAA;EEnEJ,uBAAA;EACA,gBAAA;EACA,+BAAA;EACA,qBAAA;EACA,4BAAA;EACA,mBAAA;AFgIJ;AA7DM;;EACE,eC5HM;ED6HN,gBCpHO;ADoLf;AA7DM;;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAgER;AA7DM;;EACE,2CAAA;EACA,eAAA;AAgER;AA3DE;EACE,4DAAA;AA6DJ;;AAzDA;EACE,cAAA;EACA,YAAA;AA4DF;AE1NY;EF4JZ;IAKI,WAAA;EA6DF;AACF;AA3DE;EACE,UAAA;EACA,SAAA;EACA,qBAAA;AA6DJ;AA3DI;EACE,YC3KF;ADwOJ;AA3DM;EACE,aAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AA6DR;AA3DQ;EE9IJ,aAAA;EACA,mBAAA;EF+IM,QCrLN;ADmPJ;AA5DU;EACE,aAAA;EACA,sBAAA;EACA,QC3LP;ADyPL;AAzDM;EACE,gCAAA;AA2DR;AAxDM;EACE,gBCjMH;AD2PL;AAvDM;EACE,eCxMJ;ADiQJ","sourcesContent":["@import \"../../../styles/variables\";\r\n@import \"../../../styles/utils\";\r\n\r\n.banner {\r\n  position: relative;\r\n  overflow: hidden;\r\n  background: $color-content-background-light;\r\n\r\n  &::before {\r\n    width: 100%;\r\n    content: \" \";\r\n    opacity: 0.2;\r\n    position: absolute;\r\n    top: 0;\r\n    bottom: 0;\r\n    height: 100%;\r\n    background-image: url(\"../../../assets/images/banner.jpg\");\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n    background-size: 100%;\r\n  }\r\n\r\n  @include responsive-media-query($media-lg, $media-md, $media-sm, $media-xs) {\r\n    &:before {\r\n      background-size: 100% 100%;\r\n    }\r\n  }\r\n\r\n  .brand-title-font {\r\n    font-weight: 700;\r\n    font-size: 44px;\r\n    line-height: $xxl;\r\n  }\r\n\r\n  .brand-title-bar {\r\n    color: $color-brand-red;\r\n  }\r\n\r\n  .banner-content {\r\n    position: relative;\r\n    margin: 80px auto;\r\n    max-width: 80%;\r\n\r\n    @include responsive-media-query($media-xs, $media-sm) {\r\n      margin: 20px auto;\r\n      max-width: 90%;\r\n    }\r\n\r\n    @include responsive-media-query($media-md) {\r\n      margin: 40px auto;\r\n      max-width: 85%;\r\n    }\r\n\r\n    .brand-title {\r\n      width: 440px;\r\n\r\n      @include responsive-media-query($media-xs, $media-sm) {\r\n        width: 220px;\r\n      }\r\n\r\n      @include responsive-media-query($media-md) {\r\n        width: 320px;\r\n      }\r\n    }\r\n\r\n    article {\r\n      width: 670px;\r\n      color: #0f0f0f;\r\n      margin: 32px auto 32px 0px;\r\n\r\n      p {\r\n        margin: 0px;\r\n      }\r\n\r\n      @include responsive-media-query($media-xs, $media-sm) {\r\n        width: 100%;\r\n        margin: 8px auto 8px 0px;\r\n      }\r\n\r\n      @include responsive-media-query($media-md) {\r\n        width: 570px;\r\n        margin: 16px auto 16px 0px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.articles {\r\n  padding: 24px 20px;\r\n  margin: 0px auto;\r\n  max-width: 80%;\r\n\r\n  @include responsive-media-query($media-xs, $media-sm) {\r\n    max-width: 90%;\r\n  }\r\n\r\n  @include responsive-media-query($media-md) {\r\n    max-width: 85%;\r\n  }\r\n\r\n  @include margin-less-header;\r\n\r\n  .tools-cards,\r\n  .case-study-cards {\r\n    display: grid;\r\n    padding: 16px 0px 24px 0px;\r\n    grid-gap: 1rem;\r\n    grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));\r\n\r\n    .card {\r\n      padding: 20px;\r\n      background: $color-white-primary;\r\n      border-radius: 8px;\r\n\r\n      .skelton {\r\n        @include skeleton-Loading;\r\n      }\r\n\r\n      .type {\r\n        display: inline-block;\r\n        font-size: $font-size-s;\r\n        text-transform: uppercase;\r\n\r\n        &.skelton {\r\n          line-height: $line-height-xxs;\r\n        }\r\n      }\r\n\r\n      .title {\r\n        margin: 0px;\r\n      }\r\n\r\n      .content {\r\n        margin: 12px 0px;\r\n        color: $color-grey-60;\r\n        height: 60px;\r\n\r\n        @include multiline-text-ellipsis;\r\n      }\r\n\r\n      .content-link {\r\n        font-size: $font-size-s;\r\n        font-weight: $font-regular;\r\n      }\r\n\r\n      img {\r\n        width: 100%;\r\n        height: 160px;\r\n        padding-bottom: 8px;\r\n      }\r\n\r\n      &:hover {\r\n        box-shadow: 0px 0px 4px rgb(0, 0, 0, 0.25);\r\n        cursor: pointer;\r\n      }\r\n    }\r\n  }\r\n\r\n  .case-study-cards {\r\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\r\n  }\r\n}\r\n\r\n.option-modal {\r\n  display: block;\r\n  width: 410px;\r\n\r\n  @include responsive-media-query($media-xs) {\r\n    width: 100%;\r\n  }\r\n\r\n  ul {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style-type: none;\r\n\r\n    li {\r\n      padding: $s;\r\n\r\n      &>.option-item-wrapper {\r\n        display: flex;\r\n        flex-direction: column;\r\n        padding: $xs 0;\r\n        cursor: pointer;\r\n\r\n        &>.option-item {\r\n          @include flex-align-center-vertical();\r\n          gap: $s;\r\n\r\n          &>.option-text-wrapper {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: $xs;\r\n          }\r\n        }\r\n      }\r\n\r\n      &:not(:last-child) {\r\n        border-bottom: $border-width-s solid $color-grey-20;\r\n      }\r\n\r\n      &:first-child {\r\n        margin-top: $ml;\r\n      }\r\n\r\n      &:nth-child(2){\r\n        margin-top: $s;\r\n      }\r\n    }\r\n  }\r\n}","$font-family: ABBVoice;\r\n\r\n$z-index-dialog-backdrop: 999;\r\n\r\n// basic sizes\r\n$xs: 4px;\r\n$s: 8px;\r\n$sm: 12px;\r\n$m: 16px;\r\n$ml: 24px;\r\n$l: 32px;\r\n$xl: 40px;\r\n$xxl: 48px;\r\n\r\n// font sizes\r\n$font-size-xxs: 10px;\r\n$font-size-xs: 12px;\r\n$font-size-s: 14px;\r\n$font-size-m: 16px;\r\n$font-size-ml: 20px;\r\n$font-size-l: 24px;\r\n$font-size-xl: 32px;\r\n$font-size-xxl: 40px;\r\n$font-size-xxxl: 48px;\r\n\r\n// font weight\r\n$font-regular: 400;\r\n$font-medium: 600;\r\n\r\n// line heights\r\n$line-height-xxs: 12px;\r\n$line-height-xs: 14px;\r\n$line-height-s: 16px;\r\n$line-height-m: 20px;\r\n$line-height-xl: 24px;\r\n\r\n$small-heading-text: 16px;\r\n$element-small-height: 32px;\r\n$element-medium-height: 40px;\r\n$element-large-height: 48px;\r\n\r\n$border-width-s: 1px;\r\n$border-width-m: 2px;\r\n$border-width-l: 4px;\r\n\r\n$border-radius-xxs: 2px;\r\n$border-radius-xs: 4px;\r\n$border-radius-s: 8px;\r\n$border-radius-m: 12px;\r\n$border-radius-l: 16px;\r\n$border-radius-xl: 20px;\r\n$border-radius-xxl: 24px;\r\n\r\n// colors\r\n//brand colors\r\n$color-brand-black: #000000;\r\n$color-brand-red: #ff000f;\r\n$color-brand-white: #ffffff;\r\n\r\n$color-red-100: #3e0000;\r\n$color-red-90: #5c0006;\r\n$color-red-80: #a30005;\r\n$color-red-70: #cc0815;\r\n$color-red-60: #e12e2e;\r\n$color-red-50: #ff4754;\r\n$color-red-40: #ff757e;\r\n$color-red-30: #ff99a0;\r\n$color-red-20: #ffc9cd;\r\n$color-red-10: #ffe8e9;\r\n\r\n$color-grey-100: #0f0f0f;\r\n$color-grey-90: #1f1f1f;\r\n$color-grey-80: #333333;\r\n$color-grey-70: #525252;\r\n$color-grey-60: #686868;\r\n$color-grey-50: #848484;\r\n$color-grey-40: #9f9f9f;\r\n$color-grey-30: #bababa;\r\n$color-grey-20: #dbdbdb;\r\n$color-grey-10: #ebebeb;\r\n\r\n$color-blue-100: #080261;\r\n$color-blue-90: #150c9b;\r\n$color-blue-80: #2c20d4;\r\n$color-blue-70: #2a35ff;\r\n$color-blue-60: #3366ff;\r\n$color-blue-50: #4c85ff;\r\n$color-blue-40: #77a3fc;\r\n$color-blue-30: #9ebef7;\r\n$color-blue-20: #c5dff9;\r\n$color-blue-10: #e0f0ff;\r\n\r\n//blue-ui\r\n$color-ui-blue-10: #e0f0ff;\r\n$color-ui-blue-20: #c5e0fa;\r\n$color-ui-blue-30: #9ebff7;\r\n$color-ui-blue-40: #77a3fc;\r\n$color-ui-blue-50: #4d85ff;\r\n$color-ui-blue-60: #3366ff;\r\n$color-ui-blue-70: #2a35ff;\r\n$color-ui-blue-80: #2c20d4;\r\n$color-ui-blue-90: #160c9c;\r\n$color-ui-blue-100: #080261;\r\n\r\n//status colors\r\n$color-status-error: #ef3934;\r\n$color-status-error-background: #fbf0f0;\r\n$color-status-warning: #ffa200;\r\n$color-status-warning-background: #fef9ef;\r\n$color-status-info: #0052ff;\r\n$color-status-info-background: #d8e4ff;\r\n$color-status-success: #21a67a;\r\n$color-status-success-background: #eef8f5;\r\n$color-status-unknown: #bababa;\r\n$color-status-unknown-background: #f5f5f5;\r\n\r\n$color-white-primary: #ffffff;\r\n$color-white-secondary: #fafafa;\r\n$color-white-tertiary: #f5f5f5;\r\n$color-black-primary: #000000;\r\n$color-black-secondary: #050505;\r\n$color-black-tertiary: #0A0A0A;\r\n\r\n// data-viz colors\r\n$color-green-100: #011900;\r\n$color-green-90: #10290e;\r\n$color-green-80: #1a4717;\r\n$color-green-70: #1e6119;\r\n$color-green-60: #477a43;\r\n$color-green-50: #51a34b;\r\n$color-green-40: #75ba70;\r\n$color-green-30: #98d694;\r\n$color-green-20: #bfedbb;\r\n$color-green-10: #e2f7df;\r\n\r\n//Opacity colors\r\n$color-black-opacity-base: #000000;\r\n$color-black-opacity-90: rgb($color-black-opacity-base, 0.88);\r\n$color-black-opacity-80: rgb($color-black-opacity-base, 0.80);\r\n$color-black-opacity-70: rgb($color-black-opacity-base, 0.72);\r\n$color-black-opacity-60: rgb($color-black-opacity-base, 0.64);\r\n$color-black-opacity-50: rgb($color-black-opacity-base, 0.56);\r\n$color-black-opacity-40: rgb($color-black-opacity-base, 0.48);\r\n$color-black-opacity-30: rgb($color-black-opacity-base, 0.40);\r\n$color-black-opacity-20: rgb($color-black-opacity-base, 0.32);\r\n$color-black-opacity-10: rgb($color-black-opacity-base, 0.24);\r\n$color-black-opacity-8: rgb($color-black-opacity-base, 0.16);\r\n$color-black-opacity-6: rgb($color-black-opacity-base, 0.12);\r\n$color-black-opacity-4: rgb($color-black-opacity-base, 0.08);\r\n$color-black-opacity-2: rgb($color-black-opacity-base, 0.04);\r\n\r\n//text colors\r\n$color-text-white-primary: #ffffff;\r\n$color-text-white-secondary: #dbdbdb;\r\n$color-text-white-disabled: rgba($color-text-white-primary, 0.4);\r\n\r\n$color-text-black-primary: #1f1f1f;\r\n$color-text-black-secondary: #696969;\r\n$color-text-black-disabled: rgba($color-text-black-primary, 0.4);\r\n\r\n\r\n// second-level tokens\r\n$primary-text-on-light: $color-grey-90;\r\n$primary-text-on-dark: $color-grey-20;\r\n$secondary-text-on-light: $color-grey-60;\r\n$secondary-text-on-dark: $color-grey-50;\r\n$tertiary-text-on-light: $color-grey-30;\r\n$tertiary-text-on-dark: $color-grey-70;\r\n\r\n$half-opacity-backdrop-on-light: rgba($color-grey-80, 0.5);\r\n$half-opacity-backdrop-on-dark: rgba($color-grey-100, 0.5);\r\n$full-opacity-backdrop-on-light: rgba($color-grey-80, 1);\r\n$full-opacity-backdrop-on-dark: rgba($color-grey-100, 1);\r\n\r\n$color-content-background-light: $color-white-primary;\r\n$color-content-background-light-snow: $color-white-primary;\r\n$color-content-background-light-cloud: #F5F5F5;\r\n$color-content-background-dark: $color-grey-80;\r\n$color-content-background-dark-graphite: #333333;\r\n$color-content-background-dark-charcoal: $color-grey-90;\r\n\r\n$border-saperator-color: #ebebeb;\r\n$text-disabled-color: rgb(31, 31, 31, 0.4);\r\n\r\n//Border for input controls\r\n$control-border-color: $color-grey-20;\r\n$control-border-lg: 2px solid $control-border-color;\r\n$control-border-md: 1px solid $control-border-color;\r\n$control-border-radius: 4px;\r\n\r\n$control-border-separator: 1px solid rgba(210, 210, 210, 0.8);\r\n\r\n//media breakpoints\r\n$media-xs: \"extra-small\";\r\n$media-sm: \"small\";\r\n$media-md: \"medium\";\r\n$media-lg: \"large\";\r\n$media-xl: \"extra-large\";","@import \"variables\";\r\n\r\n//this will eliminate use of @media for writing responsive CSS\r\n@mixin responsive-media-query($sizes...) {\r\n    @each $size in $sizes {\r\n        //for extra-small screen\r\n        @if ($size ==$media-xs) {\r\n            @media only screen and (max-width: 576px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        //for small screen\r\n        @if ($size ==$media-sm) {\r\n            @media only screen and (min-width: 576px) and (max-width: 768px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        //for medium screen\r\n        @if ($size ==$media-md) {\r\n            @media only screen and (min-width: 768px) and (max-width: 992px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        //for large screen\r\n        @if ($size ==$media-lg) {\r\n            @media only screen and (min-width: 992px) and (max-width: 1200px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        //for extra-large screen\r\n        @if ($size ==$media-xl) {\r\n            @media only screen and (min-width: 1200px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@mixin flex-align-center-vertical() {\r\n    display: flex;\r\n    align-items: center;\r\n    @content;\r\n}\r\n\r\n@mixin margin-less-header() {\r\n    h1,\r\n    h2,\r\n    h3,\r\n    h4,\r\n    h5,\r\n    h6 {\r\n        margin: 0px;\r\n        @content;\r\n    }\r\n}\r\n\r\n@mixin text-ellipsis() {\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    @content;\r\n}\r\n\r\n@mixin multiline-text-ellipsis() {\r\n    text-overflow: ellipsis;\r\n    overflow: hidden;\r\n    display: -webkit-box !important;\r\n    -webkit-line-clamp: 3;\r\n    -webkit-box-orient: vertical;\r\n    white-space: normal;\r\n    @content;\r\n}\r\n\r\n@mixin skeleton-Loading() {\r\n    width: auto;\r\n    border-radius: $xs;\r\n    animation: skeleton-loading 1s linear infinite alternate;\r\n    color: transparent !important;\r\n    user-select: none;\r\n\r\n    &.skeleton-text-limit {\r\n        line-height: 10px !important;\r\n        margin-top: $xs;\r\n    }\r\n\r\n    @keyframes skeleton-loading {\r\n        0% {\r\n            background-color: $color-grey-20;\r\n        }\r\n\r\n        100% {\r\n            background-color: $color-grey-10;\r\n        }\r\n    }\r\n\r\n    @content;\r\n}\r\n\r\n@mixin icon-color($color) {\r\n    .icon-inner {\r\n        fill: $color;\r\n    }\r\n}\r\n\r\n@mixin abb-cursor {\r\n    &.abb-cursor {\r\n        &::before {\r\n            content: \"\\2014\";\r\n            color: $color-brand-red;\r\n            display: block;\r\n            font-size: $font-size-l;\r\n            font-weight: bold;\r\n            line-height: 30px;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
